import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
// import { getMappedAcc } from '../../store/user/selectors'
import { getMonthClosedBetweenDepositAndSalesMismatch } from '../../store/settings/selectors'

export function MonthClosedBetweenDepositAndSalesMismatch() {

  const monthClosedMismatch = useSelector(getMonthClosedBetweenDepositAndSalesMismatch);

  const closedMonthChecker = () => {
    return monthClosedMismatch;
  }
  const [mismatchMonthClosed, setMismatchMonthClosed] = useState(closedMonthChecker())

  useEffect(() => {
    setMismatchMonthClosed(closedMonthChecker())
  }, [monthClosedMismatch]);

  return mismatchMonthClosed
}